import { createTestIds } from '../../utils';

export const getCardTestIds = createTestIds('card', [] as const);
